export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://barcode-scaner-backend.onrender.com/api',
  endpoints: {
    login: '/admin/login',
    register: '/users/register',
    users: '/users',
    products: '/products',
    scanHistory: '/products/scan-history',
    scanLogs: '/scans/scan-log',
    registerEmployee: '/admin/register-employee',
    createProduct: '/products/create',
    createCompany: '/admin/create-company',
    changeRole: (id) => `/users/${id}/change-role`,
    toggleUserStatus: (id) => `/users/${id}/toggle-status`,
    textureImages: (barcode) => `/texture/images/${barcode}`,
  },
};
